export default __webpack_public_path__ + "static/media/dds5168b-5.a0cd619a.png";